import { AuthUser } from "../../types/models/AuthUser";


export const authRole = {
  admin: ["admin"],
  user: ["user", "admin"],
  superAdmin: ["Super Admin"],
  marketing: ["marketing", "Super Admin"],
};


export enum RoutePermittedRole {
  Admin = "admin",
  User = "user",
  SuperAdmin = "Super Admin",
  Marketing = "marketing",
}

export const defaultUser: AuthUser = {
  uid: "john-alex",
  displayName: "John Alex",
  email: "demo@example.com",
  token: "access-token",
  role: "user",
  photoURL: "/assets/images/avatar/A11.jpg",
  createdOn: ""
};
export const getInitialUrl = () => localStorage.getItem("initialUrl") || "/signin";
 

